module.exports = __webpack_public_path__ + "media/images/patterns/pattern-1-f43a50752338e15fb2c3e17bf8b8e11b.svg";